import _asyncToGenerator from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
import { resolveLetterAssets, uploadLetterAssets } from "@/services/letter";
import { ASSET_PREFIX, resolvedAssetCache } from "./asset-cache";
import { extensionFromDataUrl } from "./data-url";

/** Returns a URL without its query string. */
function baseUrl(url) {
  var _url$split$;
  return (_url$split$ = url.split("?")[0]) !== null && _url$split$ !== void 0 ? _url$split$ : url;
}

/** Replaces `workspace-asset://` image srcs with presigned URLs for display/editing. */
export function resolveLetterImages(_x, _x2) {
  return _resolveLetterImages.apply(this, arguments);
}

/** Uploads new (data URL) images and rewrites every asset src back to `workspace-asset://` for saving. */
function _resolveLetterImages() {
  _resolveLetterImages = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(html, workspaceId) {
    var doc, images, uuids, resolved;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          if (!(!html || typeof document === "undefined")) {
            _context.n = 1;
            break;
          }
          return _context.a(2, html);
        case 1:
          doc = new DOMParser().parseFromString(html, "text/html");
          images = Array.from(doc.querySelectorAll("img[src^=\"".concat(ASSET_PREFIX, "\"]")));
          uuids = images.map(function (image) {
            var _image$getAttribute;
            return ((_image$getAttribute = image.getAttribute("src")) !== null && _image$getAttribute !== void 0 ? _image$getAttribute : "").slice(ASSET_PREFIX.length);
          }).filter(Boolean);
          if (uuids.length) {
            _context.n = 2;
            break;
          }
          return _context.a(2, html);
        case 2:
          _context.n = 3;
          return resolveLetterAssets(workspaceId, uuids);
        case 3:
          resolved = _context.v;
          images.forEach(function (image) {
            var _image$getAttribute2;
            var src = (_image$getAttribute2 = image.getAttribute("src")) !== null && _image$getAttribute2 !== void 0 ? _image$getAttribute2 : "";
            var url = resolved[src.slice(ASSET_PREFIX.length)];
            if (url) {
              resolvedAssetCache.set(baseUrl(url), src);
              image.setAttribute("src", url);
            }
          });
          return _context.a(2, doc.body.innerHTML);
      }
    }, _callee);
  }));
  return _resolveLetterImages.apply(this, arguments);
}
export function processLetterForSave(_x3, _x4) {
  return _processLetterForSave.apply(this, arguments);
}
function _processLetterForSave() {
  _processLetterForSave = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(html, workspaceId) {
    var doc, images, locals, mapping;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          if (!(!html || typeof document === "undefined")) {
            _context2.n = 1;
            break;
          }
          return _context2.a(2, html);
        case 1:
          doc = new DOMParser().parseFromString(html, "text/html");
          images = Array.from(doc.querySelectorAll("img"));
          locals = [];
          images.forEach(function (image, index) {
            var _image$getAttribute3;
            var src = (_image$getAttribute3 = image.getAttribute("src")) !== null && _image$getAttribute3 !== void 0 ? _image$getAttribute3 : "";
            if (src.startsWith("data:")) {
              locals.push({
                assetUrl: src,
                base64: src,
                filename: "image-".concat(index, ".").concat(extensionFromDataUrl(src))
              });
            }
          });
          if (!locals.length) {
            _context2.n = 3;
            break;
          }
          _context2.n = 2;
          return uploadLetterAssets(workspaceId, locals);
        case 2:
          mapping = _context2.v;
          images.forEach(function (image) {
            var _image$getAttribute4;
            var uuid = mapping[(_image$getAttribute4 = image.getAttribute("src")) !== null && _image$getAttribute4 !== void 0 ? _image$getAttribute4 : ""];
            if (uuid) image.setAttribute("src", "".concat(ASSET_PREFIX).concat(uuid));
          });
        case 3:
          images.forEach(function (image) {
            var _image$getAttribute5;
            var src = (_image$getAttribute5 = image.getAttribute("src")) !== null && _image$getAttribute5 !== void 0 ? _image$getAttribute5 : "";
            if (src.startsWith("data:") || src.startsWith(ASSET_PREFIX)) return;
            var assetUrl = resolvedAssetCache.get(baseUrl(src));
            if (assetUrl) image.setAttribute("src", assetUrl);
          });
          return _context2.a(2, doc.body.innerHTML);
      }
    }, _callee2);
  }));
  return _processLetterForSave.apply(this, arguments);
}